import isEqual from 'lodash.isequal';
import { api } from 'redux-store/api';
import {
  IGetLocationsForImportResponse,
  IGetLocationsForImportArgs,
  IImportLocationsBody,
  TGetProjectLocationsResponse,
  IGetProjectLocationsArgs,
  IProjectLocation,
  ICreateProjectLocationBody,
} from './index';

enum Endpoints {
  LOCATION = 'project-selection/room/',
  IMPORT_LOCATION = 'project-selection/room/import/',
}

export const projectLocationApi = api.injectEndpoints({
  endpoints: ({ mutation, query }) => ({
    getLocationsForImport: query<IGetLocationsForImportResponse, IGetLocationsForImportArgs>({
      query: ({ projectId }) => ({
        url: `${Endpoints.IMPORT_LOCATION}${projectId}`,
      }),
      keepUnusedDataFor: 0,
    }),

    importLocationsIntoProject: mutation<void, IImportLocationsBody>({
      query: ({ projectId, ...body }) => ({
        url: `${Endpoints.IMPORT_LOCATION}${projectId}`,
        body,
        method: 'POST',
      }),
    }),

    getProjectLocations: query<TGetProjectLocationsResponse, IGetProjectLocationsArgs>({
      query: ({ projectId, ...queryArgs }) => ({
        url: `${Endpoints.LOCATION}${projectId}`,
        params: queryArgs,
      }),
      serializeQueryArgs: ({ queryArgs: { projectId } }) => {
        return { projectId };
      },
      merge: (currentCache, newCache, { arg: { cursor } }) => {
        if (!cursor) {
          return newCache;
        }
        return {
          meta: newCache.meta,
          items: [...currentCache.items, ...newCache.items],
        };
      },
      forceRefetch: ({ currentArg, previousArg }) => {
        return !isEqual(currentArg, previousArg);
      },
      keepUnusedDataFor: 0,
    }),

    createProjectLocations: mutation<IProjectLocation, ICreateProjectLocationBody>({
      query: (data) => ({
        url: Endpoints.LOCATION,
        method: 'POST',
        body: data,
      }),
      onQueryStarted: async ({ projectId }, { dispatch, queryFulfilled }) => {
        try {
          const { data: response } = await queryFulfilled;
          dispatch(
            projectLocationApi.util.updateQueryData(
              'getProjectLocations',
              { projectId },
              (draft) => {
                if (draft?.items) {
                  draft.items.unshift(response);
                }
              }
            )
          );
        } catch {}
      },
    }),
  }),
});

export const {
  useGetProjectLocationsQuery,
  useLazyGetProjectLocationsQuery,
  useGetLocationsForImportQuery,
  useLazyGetLocationsForImportQuery,
  useCreateProjectLocationsMutation,
  useImportLocationsIntoProjectMutation,
} = projectLocationApi;
